module.exports = __webpack_public_path__ + "media/mypage/images/icons/icon_login-030b13b0085f0cc7889975854477fa7a.png";